import { useMediaQuery } from '@hooks/useMediaQuery';
import React from 'react';
import SelectableCard from '../../Components/SelectableCard';

interface CategorySelectableCardProps {
    category: Record<string, any>;

    [key: string]: any;
}

export default function CategorySelectableCard({ ...props }: CategorySelectableCardProps) {
    const { category } = props;
    const isMobile = useMediaQuery('mobile');

    return (
        <SelectableCard
            id={category.id}
            title={category.name}
            selectionType={'radio'}
            image={category.image ? category.image.thumbnail_path : null}
            showImage={true}
            border={'1px solid #DDDDDD'}
            borderRadius={isMobile ? '2px' : '12px'}
            imageHeight={isMobile ? '154px' : '265px'}
            {...props}
        />
    );
}
